module.exports = __webpack_public_path__ + "static/img/orange.8709b48c.gif";